import { render, staticRenderFns } from "./emptyPage.vue?vue&type=template&id=3f573ced&scoped=true"
import script from "./emptyPage.vue?vue&type=script&lang=js"
export * from "./emptyPage.vue?vue&type=script&lang=js"
import style0 from "./emptyPage.vue?vue&type=style&index=0&id=3f573ced&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f573ced",
  null
  
)

export default component.exports